/**
 * Created by Kieran on 22/11/2017.
 */

export default {
  methods: {
    rotate(direction) {
      let self = this;
      if (direction === 'left') {
        self.cropper.rotate(-90)
      }
      if (direction === 'right') {
        self.cropper.rotate(90);
      }
    },
    openInput() {
      $('.vue-base64-file-upload-wrapper input').click()
    },
    onLoad(dataUri) {
      let self = this;
      self.image = dataUri;
      self.cropper.bind({
        url: dataUri
      });
      self.isCropperVisible = true;
    },
    onSizeExceeded(size) {
      alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/CropperMixin/index.js